import React, { Component } from "react";
import s from "./styles.scss";
import { Button, Alert } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import GeneracionCoordinadorAdministrativoTable from "./GeneracionCoordinadorAdministrativo.table";
import { GeneracionCoordinadorAdministrativoStore } from "../../../containers/comisionesCoordinadorAdministrativo/generacion/GeneracionCoordinadorAdministrativo.store";
import { GeneracionCoordinadorAdministrativoDispatcher } from "../../../containers/comisionesCoordinadorAdministrativo/generacion/GeneracionCoordinadorAdministrativo.dispatcher";
import { ProcesoResultado } from "../../../../types/CoordinadorAdministrativoCalificacion";
import {
  errorNotification,
  successNotification
} from "../../../../utils/notifications";
import { Styled } from "../../../../toolkit/decorators/Artifact";
import { postCalificacionesReporte } from "../../../actions/comisionCoordinadorAdministrativo";

interface Props
  extends GeneracionCoordinadorAdministrativoStore,
    GeneracionCoordinadorAdministrativoDispatcher {}

interface State {
  selectedFile: File | null;
  mostrarBotonConfirmar: boolean;
  periodo: string;
  periodoDesc: string;
  downloading: boolean;
}

const MESES_NOMBRES = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre"
];

@Styled(s)
export default class GeneracionCoordinadorAdministrativoComponent extends Component<
  Props,
  State
> {
  state = {
    selectedFile: null,
    mostrarBotonConfirmar: false,
    periodo: "",
    periodoDesc: "",
    downloading: false
  };

  componentDidMount(): void {
    this.props.clearState();

    const now = new Date();
    const previousMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const year = previousMonth.getFullYear();
    const month = String(previousMonth.getMonth() + 1).padStart(2, "0");
    const periodoDesc = `${MESES_NOMBRES[previousMonth.getMonth()]} de ${year}`;

    this.setState({
      periodo: `${year}-${month}-01`,
      periodoDesc: periodoDesc
    });
  }

  onFileChange = evt => {
    if (evt.target.files && evt.target.files.length > 0) {
      this.setState({
        selectedFile: evt.target.files[0],
        mostrarBotonConfirmar: false
      });
    }
  };

  onDescartarArchivo = () => {
    this.props.clearState();
    this.setState({
      selectedFile: null,
      mostrarBotonConfirmar: false
    });
  };

  onCalcularComisiones = async () => {
    const { selectedFile } = this.state;

    if (!selectedFile) {
      errorNotification("Debe seleccionar un archivo");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    const preview = await this.props.procesarExcel(
      formData,
      this.state.periodo,
      false
    );
    if (preview.fulfilled) {
      const calificaciones = preview.calificaciones || [];
      successNotification("Comisiones calculadas, confirme su generación");
      const procesables = calificaciones.some(
        c => c.resultado !== ProcesoResultado.ERROR
      );

      this.setState({ mostrarBotonConfirmar: procesables });
    } else {
      errorNotification(preview.postingProcesarExcelError);
      this.setState({ mostrarBotonConfirmar: false });
    }
  };

  onConfirmarComisiones = async () => {
    const { selectedFile } = this.state;

    const periodo = this.state.periodo;
    const formData = new FormData();
    formData.append("file", selectedFile);

    const preview = await this.props.procesarExcel(formData, periodo, true);

    if (preview.fulfilled) {
      successNotification("Comisiones confirmadas y guardadas correctamente");
      this.props.clearState();
      this.setState({ mostrarBotonConfirmar: false, selectedFile: null });
    } else {
      errorNotification(
        preview.postingProcesarExcelError || "Error al confirmar las comisiones"
      );
    }
  };

  isWaiting = () => {
    return this.props.postingProcesarExcel || this.state.downloading;
  };

  spinnerOnWait = (label: string) => {
    return this.isWaiting() ? (
      <FontAwesomeIcon icon={faSpinner} pulse />
    ) : (
      label
    );
  };

  render() {
    const { calificaciones } = this.props;
    const { selectedFile, mostrarBotonConfirmar } = this.state;

    return (
      <>
        <div className="container">
          <div className="row mt-3">
            <div className="col-12">
              <Alert color="info">
                <strong>Periodo a procesar:</strong> {this.state.periodoDesc}
              </Alert>
            </div>
          </div>

          <div className="row mt-2">
            <div className="col-md-3">
              {!selectedFile ? (
                <Button
                  type="button"
                  className={`${s.primaryButton} ${s.fileButton}`}
                  size="sm"
                  block
                  disabled={this.isWaiting()}
                  onClick={e => {
                    if (this.isWaiting()) {
                      e.preventDefault();
                      e.stopPropagation();
                    }
                  }}
                >
                  {this.spinnerOnWait("Seleccionar archivo")}
                  <input
                    className={s.inputFile}
                    type="file"
                    accept=".xlsx,.xls"
                    title=""
                    disabled={this.isWaiting()}
                    onChange={this.onFileChange}
                  />
                </Button>
              ) : (
                <>
                  <Button
                    color="danger"
                    type="button"
                    size="sm"
                    block
                    onClick={this.onDescartarArchivo}
                    disabled={this.isWaiting()}
                  >
                    Descartar archivo
                  </Button>
                  <small className="text-muted d-block mt-1">
                    {selectedFile.name}
                  </small>
                </>
              )}
            </div>

            {selectedFile && !mostrarBotonConfirmar && (
              <div className="col-md-3">
                <Button
                  className={`${s.primaryButton}`}
                  type="button"
                  size="sm"
                  block
                  onClick={this.onCalcularComisiones}
                  disabled={this.isWaiting()}
                >
                  {this.spinnerOnWait("Calcular comisiones")}
                </Button>
              </div>
            )}

            {mostrarBotonConfirmar && (
              <div className="col-md-3">
                <Button
                  color="success"
                  type="button"
                  size="sm"
                  block
                  onClick={this.onConfirmarComisiones}
                  disabled={this.isWaiting()}
                >
                  {this.spinnerOnWait("Confirmar comisiones")}
                </Button>
              </div>
            )}
          </div>

          {calificaciones && calificaciones.length > 0 && (
            <div className="mt-4">
              <GeneracionCoordinadorAdministrativoTable
                calificaciones={calificaciones}
                loading={this.isWaiting()}
                onExport={() => {
                  this.setState({ downloading: true });
                  postCalificacionesReporte(
                    calificaciones,
                    this.state.periodoDesc,
                    () => this.setState({ downloading: false })
                  );
                }}
              />
            </div>
          )}
        </div>
      </>
    );
  }
}
